"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Main["default"];
  }
});
Object.defineProperty(exports, "anatomogramSpecies", {
  enumerable: true,
  get: function get() {
    return _Assets.supportedSpecies;
  }
});
exports.render = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _Main = _interopRequireDefault(require("./Main"));

var _Assets = require("./Assets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var render = function render(options, target) {
  _reactDom["default"].render(_react["default"].createElement(_Main["default"], options), document.getElementById(target));
};

exports.render = render;